export default __webpack_public_path__ + "static/media/gallery-wip-3d-model_01.c26bdcff.jpg";